const intlCache: Record<string, Intl.DateTimeFormat> = {};

export function formatDate(
  inputDate: Date | string,
  locale = 'en-GB',
  options?: Intl.DateTimeFormatOptions & { hideYearIfCurrent?: boolean }
) {
  const formatterOptions = getDateTimeFormatOptionsForDate(inputDate, options);

  const formatter = getFormatter(locale, formatterOptions);

  return formatter.format(new Date(inputDate));
}

export function formatDateRange(
  earliestDate: Date | string,
  latestDate: Date | string,
  locale = 'en-GB',
  options?: Intl.DateTimeFormatOptions & { hideYearIfCurrent?: boolean }
) {
  const formatterOptions = getDateTimeFormatOptionsForDateRange(
    earliestDate,
    latestDate,
    options
  );

  const formatter = getFormatter(locale, formatterOptions);

  return formatter.formatRange(new Date(earliestDate), new Date(latestDate));
}

function getFormatter(
  locale: string,
  options: Intl.DateTimeFormatOptions
): Intl.DateTimeFormat {
  const key = [locale, Object.entries(options)].toString();

  let formatter = intlCache[key];

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, options);
    intlCache[key] = formatter;
  }

  return formatter;
}

function getDateTimeFormatOptionsForDate(
  date: Date | string,
  options?: Intl.DateTimeFormatOptions & {
    hideYearIfCurrent?: boolean;
  }
): Intl.DateTimeFormatOptions {
  const currentYear = new Date().getFullYear();

  const isSameYear = new Date(date).getFullYear() === currentYear;

  return {
    day: 'numeric',
    month: 'long',
    year: options?.hideYearIfCurrent && isSameYear ? undefined : 'numeric',
    ...options,
  };
}

function getDateTimeFormatOptionsForDateRange(
  earliestDate: Date | string,
  latestDate: Date | string,
  options?: Intl.DateTimeFormatOptions & {
    hideYearIfCurrent?: boolean;
  }
): Intl.DateTimeFormatOptions {
  const currentYear = new Date().getFullYear();

  const isSameYear =
    new Date(earliestDate).getFullYear() === currentYear &&
    new Date(latestDate).getFullYear() === currentYear;

  return {
    day: 'numeric',
    month: 'short',
    year: options?.hideYearIfCurrent && isSameYear ? undefined : 'numeric',
    ...options,
  };
}
